<div class="p-8 max-w-2xl" data-tour="accounting-setup-dialog">
  <div class="flex items-center justify-between mb-6">
    <h2 class="!mb-0">Before You Connect</h2>
    <sbnb-close (click)="close()"></sbnb-close>
  </div>

  <div class="flex flex-col gap-4 mb-6">
    <div class="space-y-3">
      <strong>This integration will:</strong>

      <ul class="list list__looser">
        <li>
          Create reservation financials as Journals in your accounting software, according to your Reservation
          commission
          <strong>when a statement or invoice is published</strong>
          .
        </li>
        <li>Map your properties to Quickbooks classes/tracking categories</li>
        <li>Sync your owners with Quickbooks customers or vendors</li>
      </ul>
    </div>
    <sbnb-alert-card>Currently, only one accounting integration can be connected at a time.</sbnb-alert-card>
  </div>

  <!-- Dialog Footer -->
  <div class="flex justify-between">
    <sbnb-button
      type="secondary"
      label="Not right now"
      (clicked)="close()"
      data-tour="accounting-setup-cancel"></sbnb-button>
    <sbnb-button label="I'm ready!" (clicked)="continue()" data-tour="accounting-setup-continue"></sbnb-button>
  </div>
</div>
